import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f7a8096c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a8096c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7a8096c')) {
      api.createRecord('f7a8096c', component.options)
    } else {
      api.reload('f7a8096c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f7a8096c&scoped=true&", function () {
      api.rerender('f7a8096c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22lhjxJKoxeMs/JS/comp/Accordion.vue"
export default component.exports